/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Modal,
  Input,
  DatePicker,
} from 'antd';
import Table from 'components/Table';
import {
  getClasificacionesDeComercioCatalogo,
  getTiposDeEmpresas,
  getTiposDeEstablecimiento,
} from 'api/empresas';

import { useHistory } from 'react-router-dom';
import Select from 'components/Select';
import { DATE_FRONTEND_FORMAT, DATE_FORMAT } from 'utils/formatValues';
import LadaNumero from 'components/LadaNumero';
import moment from 'moment';
import { getUnidadesDeRecaudacion } from 'api/configuracion/unidadesDeRecaudacion';
import { getClasesDeActividadesEmpresariales } from 'api/empresas/claseDeActividadEmpresarial';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import address from 'utils/address';
import { getEmpresas } from 'api/empresas/empresas';
import FormSubmitControls from './FormSubmitControls';

export const model = 'empresa';

export const catalogsModels = [
  'tipodeempresa',
  'contribuyente',
  'clasificaciondecomercio',
  'clasedeactividadempresarial',
  'unidadderecaudacion',
  'ciudadano',
  'estadosglobales',
  'predio',
  'sectorcomercial',
  'tipodeestablecimiento'];

const EmpresaDePadronMultiple = ({
  permission,
  empresaID,
  disabled = true,
  fetchCallback,
}) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ results: [] });
  const [estblecimientos, setEstblecimientos] = useState({ results: [] });
  const [visible, setVisible] = useState(false);
  const [unidadesDeRecaudacion, setUnidadesDeRecaudacion] = useState([]);
  const [tiposDeEmpresa, setTiposDeEmpresa] = useState([]);
  const [claseActividad, setClaseActividad] = useState([]);
  const [clasificacionesDeComercio, setClasificacionesDeComercio] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _data,
        _establecimientos,
        _tiposEmpresa,
        _claseActividad,
        _clasificacionesDeComercio,
        _unidadesDeRecaudacion,
      ] = await Promise.all([
        getEmpresas({ page: 1, id: empresaID }),
        getTiposDeEstablecimiento(),
        getTiposDeEmpresas(),
        getClasesDeActividadesEmpresariales(),
        getClasificacionesDeComercioCatalogo(),
        getUnidadesDeRecaudacion(),
      ]);
      if (mounted) {
        if (fetchCallback) {
          fetchCallback(_data);
        }
        setEstblecimientos(_establecimientos);
        setUnidadesDeRecaudacion(_unidadesDeRecaudacion);
        setClasificacionesDeComercio(_clasificacionesDeComercio);
        setClaseActividad(_claseActividad);
        setTiposDeEmpresa(_tiposEmpresa);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    form.resetFields();
    setVisible(false);
  };

  const viewInfo = async () => setVisible(true);

  const editEmpresa = async () => history.push(`/padrones/empresas/?id=${selectedRowKeys[0]}`);

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue({
      ...record,
      direccion_de_ubicacion: record?.direccion_de_ubicacion ? address(record?.direccion_de_ubicacion) : 'N/A',
    });
  };

  const rowSelection = disabled ? {
    selectedRowKeys,
    type: 'radio',
  } : null;

  const columns = [
    {
      titleText: 'Clave',
      key: 'clave',
      dataIndex: 'clave',
      width: 150,
    },
    {
      titleText: 'Nombre Comercial',
      key: 'nombre_comercial',
      dataIndex: 'nombre_comercial',
      width: 300,
    },
    {
      titleText: 'RFC',
      key: 'contribuyente',
      dataIndex: 'contribuyente',
      render: (text) => text?.rfc,
      width: 300,
    },
    {
      titleText: 'Direccion',
      key: 'direccion_de_ubicacion',
      dataIndex: 'direccion_de_ubicacion',
      render: (val) => address(val),
      width: 300,
    },
    {
      titleText: 'Fecha de Apertura',
      key: 'fecha_de_apertura',
      dataIndex: 'fecha_de_apertura',
      render: (text) => (text ? moment(text, DATE_FORMAT).format(DATE_FORMAT) : 'Sin fecha de apertura en registro'),
      width: 300,
    },
  ].filter((e) => e);

  return (
    <Row align="center" justify="center" className="container">
      <Col xs={24} sm={24} md={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Table
            cols={columns}
            data={data?.results}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            rowKey="id"
            permission={permission}
            pagination={false}
            hasAllViewPermission
            customActions={[
              {
                onClick: viewInfo,
                icon: <EyeOutlined />,
                text: 'Ver Detalles',
                disabled: !selectedRowKeys.length,
              },
              {
                onClick: editEmpresa,
                icon: <EditOutlined />,
                text: 'Accesar a Empresa',
                disabled: !selectedRowKeys.length,
              },
            ]}
          />
          <Modal
            title={(
              <FormSubmitControls
                label="Vista General"
                onCancel={onCancel}
                loading={loading}
              />
            )}
            visible={visible}
            keyboard={!loading}
            maskClosable={!loading}
            onCancel={onCancel}
            forceRender
            footer={null}
            closable={false}
          >
            <Form
              name="info"
              layout="vertical"
              form={form}
              scrollToFirstError
              initialValues={{ tipo_de_persona: 1 }}
            >
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  label="Nombre comercial"
                  name="nombre_comercial"
                >
                  <Input disabled={disabled} allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="unidad_recaudadora"
                  label="Unidad Recaudadora"
                >
                  <Select disabled={disabled} dataSource={unidadesDeRecaudacion} allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="tipo_de_empresa"
                  label="Tipo de Empresa"
                  hasFeedback
                >
                  <Select disabled={disabled} dataSource={tiposDeEmpresa} />
                </Form.Item>
              </Col>
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  label="Tipo de establecimiento"
                  name="tipo_de_establecimiento"
                >
                  <Select
                    disabled={!disabled}
                    dataSource={estblecimientos}
                    labelProp="nombre"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="clasificacion_de_comercio"
                  label="Clasificación de comercio"
                  hasFeedback
                >
                  <Select disabled={!disabled} dataSource={clasificacionesDeComercio} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="clase_actividad_empresarial_principal"
                  label="Clase Actividad"
                  hasFeedback
                  tooltip="Clase Actividad Empresarial"
                >
                  <Select disabled={disabled} dataSource={claseActividad} allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_de_apertura"
                  label="Fecha de apertura"
                  hasFeedback
                >
                  <DatePicker disabled={disabled} format={DATE_FRONTEND_FORMAT} placeholder="" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="fecha_de_alta_de_padron_empresa"
                  label="Fecha de alta de Padrón"
                  hasFeedback
                >
                  <DatePicker disabled={disabled} format="DD/MM/YYYY" placeholder="" />
                </Form.Item>
              </Col>
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  label="Dirección de Ubicación"
                  name="direccion_de_ubicacion"
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              {/* <Col md={24} sm={24} xs={24}>
                <Form.Item
                  label="Número de teléfono local"
                  name="telefono_local"
                >
                  <Input allowClear />
                </Form.Item>
              </Col> */}
              <LadaNumero
                form={form}
                names={{
                  lada: 'lada_fijo',
                  numero_de_telefono: 'telefono_fijo',
                }}
                tooltip="Teléfono Fijo de la Empresa"
                label="Teléfono Fijo"
                fullSize
                disabled={disabled}
              />
              <LadaNumero
                form={form}
                names={{
                  lada: 'lada_celular',
                  numero_de_telefono: 'telefono_celular',
                }}
                tooltip="Teléfono Celular de la Empresa"
                label="Teléfono Celular"
                fullSize
                disabled={disabled}
              />
              <Form.Item
                name="observaciones"
                label="Observaciones"
              >
                <Input.TextArea
                  disabled={!disabled}
                  autoSize={{ minRows: 2, maxRows: 3 }}
                  maxLength={250}
                  allowClear
                />
              </Form.Item>
            </Form>
          </Modal>
        </Spin>
      </Col>
    </Row>
  );
};

export default EmpresaDePadronMultiple;
